import React, { Component } from 'react';
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';

class ResumenModeloLiquidacion extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeCheck = this.changeCheck.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeCheck(event) {
        this.props.changeCheck(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        const { codigoNovedad, data } = this.props;
        const { empresaDatos, funcionesDelUsuario, novedadesEmpresaDatos, seEstaEditando } = data;
        const esNovedadEditada = data.esNovedadEditada.find(ens => ens.campoCodigo == codigoNovedad).editado;

        //////////Novedad Generar reporte cuenta central////////////////
        const novedad = (novedadesEmpresaDatos || []).find(x => x.NovedadCampoCodigo == codigoNovedad);
        const leyenda = "Toma los gastos de emisión del resumen del modelo de liquidación";

        let checked = (empresaDatos.TomaGastosModeloLiquidacion || false);
        let descripcion = ((checked == false) ? "NO" : "√") + " " + leyenda;

        if (novedad) {
            if (!isNaN(novedad.ValorAnterior)) {
                novedad.ValorAnteriorFormateado = ((novedad.ValorAnterior == 0) ? "NO" : "SI");
                novedad.ValorAnterior = ((novedad.ValorAnterior == 0) ? false : true);
            } else {
                novedad.ValorAnteriorFormateado = "Sin especificar";
            }

            if (!isNaN(novedad.ValorNovedad)) {
                descripcion = ((novedad.ValorNovedad == 0) ? "NO" : "SI") + " " + leyenda;
                novedad.ValorNovedad = ((novedad.ValorNovedad == 0) ? false : true);
            }

            if (!esNovedadEditada) {
                checked = novedad.ValorNovedad;
            }
        }
        ///////////////////////////////////////////////////

        let componente = (
            <div className="col-xs-12">
                <ul className="no-bullets no-padding no-margin">
                    <li className="inlineListItem2 lg-margin">
                        <div className="default-checkbox">
                            <input id="chkPermiteAdelantosAcreditacion" name="chkPermiteAdelantosAcreditacion" type="checkbox" onChange={this.changeCheck} checked={checked} value={checked} />
                            <label className="label-primary" htmlFor="chkPermiteAdelantosAcreditacion"></label>
                        </div>
                    </li>
                    <li className="inlineListItem2">
                        <label className="label-primary" htmlFor="chkPermiteAdelantosAcreditacion">{leyenda}</label>
                    </li>
                </ul>
            </div>
        );

        return (
            <GenericEditPanel
                componente={componente}
                error={false}
                permisoUsuario={funcionesDelUsuario}
                muestraDescripcion={false}
                novedad={novedad}
                seEstaEditando={seEstaEditando}
                textPanel={descripcion || "Sin especificar"}
                value={checked}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedad, 2, empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedad, 3, empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default ResumenModeloLiquidacion;